import React, { PureComponent } from 'react';

class Key extends PureComponent {
    render() {
        const { categories, toggleKey } = this.props;

        return (
            <div className="keywrap">
                <button className="keywrap-close" onClick={(e) => toggleKey()}>
                    <span className="sr-only">Close key</span>
                </button>
                <h3 className="keywrap-title">What do the icons mean?</h3>
                <div className="keywrap-wrap">
                    <div className="row">
                        {categories.map(cat => 
                            <div className="col-sm-6">
                                <div className="keywrap-item">
                                    <div className={`keyitem ${cat.category.class}`}>
                                        {cat.category.title}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default Key;


// WEBPACK FOOTER //
// ./src/Results/Key.js